import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';

import ComponentType from 'common/src/app/data/enum/ComponentType';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import Pages from 'common/src/app/data/enum/Pages';
import IconName from 'common/src/app/data/enum/IconName';

import Icon from '../../atoms/Icon';
import TextNew from '../../atoms/TextNew';
import HeadingButton from '../../atoms/HeadingButton';

import './public-navigation-links.scss';

const PublicNavigationLinks = ({ publicHost, accountHost, showMenu }, {}, className) => (
  <div className={className}>
    <HeadingButton />
    <nav className={showMenu && 'menu-active'}>
      <Link href={publicHost + Pages.HOME}>
        <Icon name={IconName.HOME} width={22} height={22} />
        <TextNew.Formal localeId="publicNavigationLinks.home" />
      </Link>
      <Link href={publicHost + Pages.UK_PUBLIC_HOW_IT_WORKS}>
        <Icon name={IconName.FEATURES} width={22} height={22} />
        <TextNew.Formal localeId="publicNavigationLinks.howItWorks" />
      </Link>
      <Link href={publicHost + Pages.UK_PUBLIC_RECIPE_SEARCH}>
        <Icon name={IconName.RECIPES} width={22} height={22} />
        <TextNew.Formal localeId="publicNavigationLinks.recipes" />
      </Link>
      <Link href={publicHost + Pages.UK_PUBLIC_SUCCESS_STORIES}>
        <Icon name={IconName.SUCCESS_STORIES} width={22} height={22} />
        <TextNew.Formal localeId="publicNavigationLinks.successStories" />
      </Link>
      <Link href={accountHost + Pages.LOGIN} className="sign-in">
        <Icon name={IconName.SIGNIN} />
        <TextNew.Formal localeId="publicNavigationLinks.signIn" />
      </Link>
    </nav>
  </div>
);

PublicNavigationLinks.propTypes = {
  publicHost: PropTypes.string,
  accountHost: PropTypes.string,
  showMenu: PropTypes.bool,
};

export default withFunctionalClassName(
  ComponentType.MOLECULE,
  'PublicNavigationLinks',
)(PublicNavigationLinks);
